export type Env = 'prt' | 'staging' | 'dev' | 'prod';
export type typeCachierEnv = 'development' | 'staging' | 'prt' | 'production';

// 通过检测url的域名判断环境
export function getEnvByUrl(url: string): Env {
    if (url.includes('www.kwai.com')) return 'prod';
    if (url.includes('api-kwai.staging.kuaishou.com')) return 'staging';
    if (url.includes('kwai-pwa-hzs.test.gifshow.com')) return 'prt';
    if (url.includes('dev') || url.includes('localhost') || url.includes(':9903') || url.includes('kproxy.corp.kuaishou.com')) return 'dev';
    return 'prod';
}
export const ENV = getEnvByUrl(window.location.href.split('?')[0]);
export const isStaging = ENV === 'staging';
export const isPRT = ENV === 'prt';
export const isProd = ENV === 'prod';
export const isDev = ENV === 'dev';

// 获取 casher SDK 的环境
export function getCasherEnv(): typeCachierEnv {
    const env = getEnvByUrl(window.location.href);
    if (env === 'dev') return 'development';
    if (env === 'staging') return 'staging';
    if (env === 'prt') return 'prt';
    if (env === 'prod') return 'production';
    return env;
}

// 获取当前环境
export function getEnv(): Env {
    return getEnvByUrl(window.location.href);
}
console.log('env =>', getEnv());

// 获取线上域名，由于线上有AZ域名，所以域名不能写死
export function getProdDomin() {
    return location.hostname;
}

// 老H5 domain
export const getDomain = () => {
    return '';
};

// 老H5 domain
export const getH5Domain = (env?: string) => {
    const prodDomain = 'https://m-shop.kwai.com';
    const prtDomain = 'https://m-shop.prt.kuaishou.com';
    const stagingDomain = 'https://m-shop.staging.kuaishou.com';
    const runtimeEnv = env || getEnv();

    if (runtimeEnv === 'dev') return stagingDomain;
    if (runtimeEnv === 'staging') return stagingDomain;
    if (runtimeEnv === 'prt') return prtDomain;
    return prodDomain;
};

// krn domain
export const getKrnDomain = (env?: string) => {
    const prodDomain = `https://${getProdDomin()}`;
    const prtDomain = 'https://m-shop-krn.prt.kuaishou.com';
    const stagingDomain = 'https://m-shop-krn.staging.kuaishou.com';
    const devDomain = '';

    const runtimeEnv = env || getEnv();
    if (runtimeEnv === 'prod') return prodDomain;
    if (runtimeEnv === 'prt') return prtDomain;
    if (runtimeEnv === 'staging') return stagingDomain;
    if (runtimeEnv === 'dev') return prodDomain;
    return prodDomain;
};

export const api = (path: string) => {
    return path;
};

export interface IResp<T = any> {
    result: number;
    data: T;
    message: string;
}
